export enum SufixType {
  Euro = 'EUR',
  Percentage = '%',
  None = '',
}
